<template>
    <LayoutMain>
        <SubSection class="pt-80 guide">
            <div class="title_area">
                <h1>이용약관</h1>
                <div class="handler_wrap">
                    <span>현행 시행일자</span>
                    <select @change="changeDate" :value="selectedContent?.key">
                        <option v-for="content of contentList" :value="content.key" :key="content.key">
                            {{ content.title }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="content_area" v-html="selectedContent?.content" ref="content"></div>
        </SubSection>
    </LayoutMain>
</template>

<script>
import LayoutMain from '@/layouts/LayoutMain.vue';
import SubSection from '@/components/SubSection.vue';
import { getPrivacyList } from '@/api';

export default {
    components: {
        LayoutMain,
        SubSection,
    },
    data() {
        return {
            selectedContent: null,
            contentList: [],
        };
    },
    async mounted() {
        await this.getPrivacy();
    },
    watch: {
        async $route() {
            await this.getPrivacy();
        },
    },
    methods: {
        wrapTables() {
            const content = this.$refs.content;
            const tables = content.querySelectorAll('table');

            tables.forEach((table) => {
                if (table.parentElement.classList.contains('table-wrapper')) return; // 중복 방지

                const wrapper = document.createElement('div');
                wrapper.className = 'table-wrapper';
                wrapper.style.overflowX = 'auto';
                wrapper.style.width = '100%';

                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            });
        },
        removeLastBorder() {
            const content = this.$refs.content;
            const tables = content.querySelectorAll('table');

            tables.forEach((table) => {
                const rows = table.querySelectorAll('tr');
                const colMap = [];
                let maxCols = 0;

                // 위치 매핑
                rows.forEach((row, rowIndex) => {
                    if (!colMap[rowIndex]) colMap[rowIndex] = [];

                    let colPos = 0;
                    const cells = row.children;

                    for (let i = 0; i < cells.length; i++) {
                        const cell = cells[i];
                        if (cell.style.display === 'none') continue; // 보이지 않는 셀은 건너뜀

                        while (colMap[rowIndex][colPos]) colPos++;

                        const colspan = parseInt(cell.getAttribute('colspan')) || 1;
                        const rowspan = parseInt(cell.getAttribute('rowspan')) || 1;

                        for (let r = 0; r < rowspan; r++) {
                            for (let c = 0; c < colspan; c++) {
                                if (!colMap[rowIndex + r]) colMap[rowIndex + r] = [];
                                colMap[rowIndex + r][colPos + c] = cell;
                            }
                        }

                        colPos += colspan;
                    }

                    maxCols = Math.max(maxCols, colMap[rowIndex].length);
                });

                // 중복 제거용 셀 추적
                const alreadyHandled = new Set();

                colMap.forEach((row) => {
                    if (row && row[maxCols - 1]) {
                        const lastCell = row[maxCols - 1];
                        if (lastCell && !alreadyHandled.has(lastCell)) {
                            lastCell.style.borderRight = 'none';
                            alreadyHandled.add(lastCell);
                        }
                    }
                });
            });
        },
        async getPrivacy() {
            try {
                const response = await getPrivacyList('terms');
                this.contentList = response.list.map((item) => ({
                    key: item.idx,
                    title: item.subject,
                    content: item.contents,
                }));

                if (!this.selectedContent) {
                    this.initContent();
                }
            } catch (error) {
                this.contentList = [];
            }
        },
        initContent() {
            if (this.contentList.length > 0) {
                this.changeDate({ target: { value: this.contentList[0].key } });
            }
        },
        changeDate({ target: { value: key } }) {
            const result = this.contentList.find((el) => el.key === key);
            if (result) {
                this.selectedContent = result;
                this.$router.replace({ path: this.$route.path, query: { key } });
                this.$nextTick(() => {
                    this.removeLastBorder();
                    this.wrapTables();
                });
            } else {
                this.initContent();
            }
        },
    },
    created() {
        if (this.$route.query.key) this.changeDate({ target: { value: this.$route.query.key } });
        else this.initContent();
    },
};
</script>
